/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Doc_Police_ReportInputs */

const en_case_doc_police_report = /** @type {(inputs: Case_Doc_Police_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Police report (BO) or DAT`)
};

const pt_br2_case_doc_police_report = /** @type {(inputs: Case_Doc_Police_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boletim de Ocorrência (BO) ou DAT`)
};

/**
* | output |
* | --- |
* | "Police report (BO) or DAT" |
*
* @param {Case_Doc_Police_ReportInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_doc_police_report = /** @type {((inputs?: Case_Doc_Police_ReportInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Doc_Police_ReportInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_doc_police_report(inputs)
	return pt_br2_case_doc_police_report(inputs)
});